import type { Nullable } from "models-webgl2";
import { Webgl2Component } from "../../webgl2-component";
import { Webgl2dRenderer } from "../webgl2d-renderer";
import { Webgl2Tool } from "./webgl2-tool";

export class SelectionTool extends Webgl2Tool {
  private _currComponent: Nullable<Webgl2Component>;

  constructor(private readonly _renderer: Webgl2dRenderer) {
    super();
  }

  public onMouseDown(e: MouseEvent) {
    return this._handleDown(e);
  }

  public onMouseMove(e: MouseEvent) {
    return this._handleMove(e);
  }

  public onMouseEnded(e: MouseEvent) {
    return this._handleUp(e);
  }

  public onTouchStart(e: TouchEvent) {
    return this._handleDown(e);
  }

  public onTouchMove(e: TouchEvent) {
    return this._handleMove(e);
  }

  public onTouchEnded(e: TouchEvent) {
    return this._handleUp(e);
  }

  private _handleDown(e: MouseEvent | TouchEvent) {
    this._currComponent = this._renderer.findComponentUnderMouse(e);

    if (this._currComponent?.onMouseDown) {
      this._currComponent?.onMouseDown(e);
    } else {
      this._renderer.selectComponent(this._currComponent);
      return false;
    }
  }

  private _handleMove(e: MouseEvent | TouchEvent) {
    this._currComponent?.onMouseMove?.(e);
  }

  private _handleUp(e: MouseEvent | TouchEvent) {
    this._currComponent?.onMouseUp?.(e);
  }
}

export default SelectionTool;
